import { render } from "./BadgeApp.vue?vue&type=template&id=029c34db&scoped=true"
import script from "./BadgeApp.vue?vue&type=script&lang=js"
export * from "./BadgeApp.vue?vue&type=script&lang=js"

import "./BadgeApp.vue?vue&type=style&index=0&id=029c34db&scoped=true&lang=css"

import exportComponent from "/var/www/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-029c34db"]])

export default __exports__